(function () {
  var PROPERTY_KEY = '_Combo';
  var LABEL_KEY = '_Combo Group';
  var GROUP_CLASS = 'ks-combo-group-header';

  function moneyCents(cents) {
    if (window.Shopify && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.ksMoneyFormat || '{{amount}}');
    }
    return '₹' + (cents / 100).toFixed(2);
  }

  function clearOldHeaders(root) {
    root.querySelectorAll('.' + GROUP_CLASS).forEach(function (el) { el.remove(); });
    root.querySelectorAll('[data-ks-combo-row]').forEach(function (el) {
      el.style.borderLeft = '';
      el.removeAttribute('data-ks-combo-row');
    });
  }

  function groupCart(cart, rootSelector, rowIdPrefix, colspan) {
    var root = document.querySelector(rootSelector);
    if (!root) return;
    var tbody = root.querySelector('tbody');
    if (!tbody) return;

    clearOldHeaders(root);

    var groups = {};
    var order = [];
    cart.items.forEach(function (item, i) {
      var combo = item.properties && item.properties[PROPERTY_KEY];
      if (!combo) return;
      if (!groups[combo]) { groups[combo] = { indices: [], label: item.properties[LABEL_KEY] || 'Custom made combo', total: 0 }; order.push(combo); }
      groups[combo].indices.push(i + 1);
      groups[combo].total += item.final_line_price;
    });

    order.forEach(function (combo) {
      var group = groups[combo];
      if (group.indices.length < 2) return;
      var firstRow = document.getElementById(rowIdPrefix + group.indices[0]);
      if (!firstRow) return;

      var header = document.createElement('tr');
      header.className = GROUP_CLASS;
      header.innerHTML = '<td colspan="' + colspan + '" style="padding:10px 12px;background:var(--color-base-background-2,#f4f4f4);font-size:12px;font-weight:700;border-left:3px solid #0F4D2C;">' +
        group.label + ' &middot; ' + group.indices.length + ' items &middot; ' + moneyCents(group.total) + '</td>';
      firstRow.parentNode.insertBefore(header, firstRow);

      group.indices.forEach(function (idx) {
        var row = document.getElementById(rowIdPrefix + idx);
        if (row) {
          row.style.borderLeft = '3px solid #E6F0EA';
          row.setAttribute('data-ks-combo-row', '1');
        }
      });
    });
  }

  function refresh() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        groupCart(cart, '#main-cart-items', 'CartItem-', 4);
        groupCart(cart, '#CartDrawer-CartItems', 'CartDrawer-Item-', 4);
      })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', refresh);
  document.addEventListener('ksbyo:combo-added', function () { setTimeout(refresh, 400); });

  var targets = ['#main-cart-items', '#CartDrawer-CartItems'];
  targets.forEach(function (sel) {
    var el = document.querySelector(sel);
    if (!el) return;
    var observer = new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (m) {
        return !(m.target.classList && m.target.classList.contains(GROUP_CLASS));
      });
      if (relevant) { clearTimeout(window.__ksComboTimer); window.__ksComboTimer = setTimeout(refresh, 250); }
    });
    observer.observe(el, { childList: true, subtree: true });
  });
})();
